import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('articleListingSection', {
    enableTaxonomyFilter: {
        title: 'Enable taxonomy filter',
        type: 'boolean'
    }
});
var validator = z.object({
    enableTaxonomyFilter: z.boolean()
}).partial();
schema.articleListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=articleListingSection.js.map